import { useMemo } from "react";
import { AgGridReact } from "@jsq/ds/core";
import { DashboardCell } from "~/pages/Dashboard/components/WorkspaceTable/CellComponents";
import { RemoveRoleButton } from "../RemoveRole";

export const useCanopyRolesTableConfiguration = () => {
  const columnDefs: AgGridReact.AgGridReactProps["columnDefs"] = useMemo(() => {
    return [
      {
        field: "groupName",
        headerName: "Role",
        cellRenderer: DashboardCell,
      },
      {
        field: "removeRole",
        headerName: "",
        cellRenderer: RemoveRoleButton,
      },
    ];
  }, []);

  return { columnDefs };
};
